import { render, staticRenderFns } from "./CheckedBoxIcon.vue?vue&type=template&id=136476e8&"
import script from "./CheckedBoxIcon.vue?vue&type=script&lang=js&"
export * from "./CheckedBoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports